/** Convert this to css grid */
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import 'isotope-packery';

const fly_why: LegacyModule = {
	init: function () {
		this.cache();
		if (!this.$grid) {
			return;
		}
		this.grid();
	},

	cache: function () {
		this.$grid = document.querySelector('#wf-instagram .grid');
		this.$grid_images = document.querySelectorAll('#wf-instagram img');
	},

	grid: function () {
		this.iso = new Isotope(this.$grid, {
			itemSelector: '.item',
			layoutMode: 'packery',
		});
		imagesLoaded(this.$grid, this.update_grid.bind(this));
	},

	update_grid: function () {
		this.iso.layout();
		this.show_images();
	},
	show_images: function () {
		for (var i = 0; i < this.$grid_images.length; i++) {
			this.$grid_images[i].style.opacity = 1;
		}
	},
};

fly_why.init();
